module.exports = __webpack_public_path__ + "img/phone.ff9a0836.png";